import { Box, Button, Divider, IconButton, MenuItem, TextField, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CallSplitIcon from "@mui/icons-material/CallSplit";
import DeleteIcon from "@mui/icons-material/Delete";
import { v4 as uuidv4 } from "uuid";
import { SPLIT_PAYMENTS_MAX_ROWS, SPLIT_PAYMENT_METHODS, SplitPaymentRow } from "./splitPayments";

type SplitPaymentRowsProps = {
    rows: Array<SplitPaymentRow>;
    onChange: (rows: Array<SplitPaymentRow>) => void;
};

export const SplitPaymentRows = ({ rows, onChange }: SplitPaymentRowsProps) => {
    const updateRow = (rowId: string, changes: Partial<SplitPaymentRow>) => {
        onChange(rows.map((row) => (row.id === rowId ? { ...row, ...changes } : row)));
    };
    const removeRow = (rowId: string) => {
        onChange(rows.filter((row) => row.id !== rowId));
    };
    const addRow = () => {
        onChange([...rows, { id: uuidv4(), payment_method: "", amount: 0 }]);
    };

    return (
        <Box display="flex" flexDirection="column" gap={1.5}>
            {rows.length > 0 && (
                <>
                    <Divider sx={{ mt: 2 }} />
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                        Outros métodos de pagamento
                    </Typography>
                </>
            )}
            {rows.map((row) => (
                <Box key={row.id} display="flex" gap={1} alignItems="center">
                    <TextField
                        select
                        size="small"
                        label="Método"
                        value={row.payment_method}
                        onChange={(event) => updateRow(row.id, { payment_method: event.target.value })}
                        sx={{ flex: 1 }}
                    >
                        {SPLIT_PAYMENT_METHODS.map((method) => (
                            <MenuItem key={method.value} value={method.value}>
                                {method.label}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        size="small"
                        type="number"
                        label="Valor"
                        defaultValue={row.amount || ""}
                        onChange={(event) => updateRow(row.id, { amount: Number(event.target.value) })}
                        inputProps={{ step: 0.01, min: 0 }}
                        sx={{ width: 140 }}
                    />
                    <IconButton color="error" size="small" aria-label="Remover pagamento" onClick={() => removeRow(row.id)}>
                        <DeleteIcon />
                    </IconButton>
                </Box>
            ))}
            {rows.length === 0 && (
                <Button variant="text" startIcon={<CallSplitIcon />} onClick={addRow} sx={{ alignSelf: "flex-start" }}>
                    Dividir pagamento
                </Button>
            )}
            {rows.length > 0 && rows.length < SPLIT_PAYMENTS_MAX_ROWS && (
                <Button variant="text" startIcon={<AddIcon />} onClick={addRow} sx={{ alignSelf: "flex-start" }}>
                    Adicionar outro método
                </Button>
            )}
        </Box>
    );
};
